import React from 'react'

class DevTools extends React.Component {
    render = () => {
        return null
    }
}

export default DevTools
